import LinearProgress, {
	linearProgressClasses
} from "@mui/material/LinearProgress";
import ThemeButton from "components/Buttons/ThemeButton";
import styled from "styled-components";

export const Button = styled(ThemeButton)`
	width: 100%;
	margin: 0.7em 0;
	font-size: 1.3125em;

	@media (min-width: 400px) {
		max-width: 14em;
	}
`;

export const MeterContainer = styled.div`
	font-size: clamp(10px, 1.25vw, 12px);
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column-reverse;
	margin-top: 6.7em;
	margin-bottom: 1em;
	position: relative;

	@media (orientation: landscape) or (min-width: 900px) {
		font-size: clamp(8px, 1.25vw, 12px);
		flex-direction: row;
	}
`;

export const UserImage = styled.img`
	width: 6.4em;
	height: 6.4em;
	border-radius: 50%;
	border: 0.4em solid #cffb4e;
	position: relative;
	right: -1em;

	@media (orientation: portrait) and (max-width: 899px) {
		right: 0;
		top: -1em;
	}
`;

export const VisibleRewardsTrack = styled.div<{ $rewardCount: number }>`
	position: relative;
	width: ${({ $rewardCount }) => `${$rewardCount * 10}em`};
	height: 12.6em;
	flex: 0 0 auto;

	@media (orientation: portrait) and (max-width: 899px) {
		width: 10em;
		height: ${({ $rewardCount }) => `${$rewardCount * 10}em`};
	}
`;

export const ProgressMeter = styled.div<{ $rewardCount: number }>`
	position: absolute;
	top: 4.3em;
	left: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: rgba(0, 0, 0, 0.5);
	width: ${({ $rewardCount }) => `${$rewardCount * 10}em`};
	height: 3.6em;
	border-top: 0.4em solid transparent;
	border-bottom: 0.4em solid transparent;
	border-image: linear-gradient(to right, #b4f362, #14b9f1) 1;
	border-image-width: 0.4em 0;
	z-index: 1;

	@media (orientation: portrait) and (max-width: 899px) {
		top: ${({ $rewardCount }) => `${$rewardCount * 5 - 1.8}em`};
		left: ${({ $rewardCount }) => `${5 - $rewardCount * 5}em`};
		transform: rotate(-90deg);
		transform-origin: center;
	}
`;

export const RewardStick = styled.div`
	content: "";
	display: block;
	width: 1em;
	height: 5.6em;
	position: absolute;
	top: 3.35em;
	right: -0.8em;
	background-color: #fff;
	border-radius: 1em;
	border: 0.3em solid #000;
	z-index: 2;

	&.completed {
		background-color: #c6ec6b;
		border: 0.3em solid #3a6922;
	}

	@media (orientation: portrait) and (max-width: 899px) {
		transform: rotate(90deg);
		top: -2.5em;
		right: 4.2em;
	}
`;

export const RewardTrack = styled.div`
	position: relative;
	display: flex;
	width: 100%;
	height: 100%;
	z-index: 3;

	@media (orientation: portrait) and (max-width: 899px) {
		flex-direction: column-reverse;
	}
`;

export const MeterBox = styled.div`
	position: relative;
	flex: 0 0 10em;
	width: 10em;
	height: 100%;

	p {
		position: absolute;
		top: 3.1em;
		left: 2.45em;
		width: 1em;
		text-align: center;
		margin: 0;
		color: #fff;
		-webkit-text-stroke-width: 0.2em;
		-webkit-text-stroke-color: #000;
		paint-order: stroke fill;
		filter: drop-shadow(0.0108em 0.0308em 0 #000);
		font-family: "Baloo";
		font-size: 3.4em;
		font-style: normal;
		font-weight: 400;
		line-height: 91.176%;

		&.completed {
			color: #c6ec6b;
			-webkit-text-stroke-color: #3a6922;
			filter: drop-shadow(0.0108em 0.0308em 0 #3a6922);
		}
	}

	@media (orientation: portrait) and (max-width: 899px) {
		height: 10em;

		p {
			top: auto;
			bottom: 2.25em;
			left: -0.8em;
			text-align: right;
		}
	}
`;

export const BorderLinearProgress = styled(LinearProgress)`
	width: 100%;
	height: 90%;

	&.${linearProgressClasses.colorPrimary} {
		background: none;
	}

	& .${linearProgressClasses.bar} {
		background: linear-gradient(-90deg, #e0679a 0%, #dc0062 50%);
		transition: transform 400ms ease-in-out;
	}
`;
